import apiClient from "./axios"

export const getInventoryAccessories = async (params = {}) => {
  const { data } = await apiClient.get("/inventory-accessories", { params })
  return data
}

export const getInventoryAccessory = async id => {
  const { data } = await apiClient.get(`/inventory-accessories/${id}`)
  return data
}

export const createInventoryAccessory = async payload => {
  const { data } = await apiClient.post("/inventory-accessories", payload)
  return data
}

export const updateInventoryAccessory = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(
    `/inventory-accessories/${id}`,
    payload
  )
  return data
}

export const deleteInventoryAccessory = async id => {
  const { data } = await apiClient.delete(`/inventory-accessories/${id}`)
  return data
}
